import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

export function FaqEditor({ faq, onChange, prefix = "air-faq" }) {
  const upd = (i, patch) => onChange(faq.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  return (
    <div className="space-y-1" data-testid={`${prefix}-editor`}>
      {faq.map((f, i) => (
        <div key={i} className="flex gap-1 items-center">
          <Input className="h-8" placeholder="Question" value={f.q} onChange={(e) => upd(i, { q: e.target.value })} data-testid={`${prefix}-q-${i}`} />
          <Input className="h-8" placeholder="Approved answer" value={f.a} onChange={(e) => upd(i, { a: e.target.value })} data-testid={`${prefix}-a-${i}`} />
          <label className={`flex items-center gap-1 whitespace-nowrap text-[11px] ${f.approved === false ? "text-amber-700" : "text-emerald-700"}`}>
            <input type="checkbox" checked={f.approved !== false} onChange={(e) => upd(i, { approved: e.target.checked })} data-testid={`${prefix}-approved-${i}`} />
            {f.approved === false ? "Draft — AI won't use" : "Approved"}
          </label>
          <Button size="sm" variant="ghost" onClick={() => onChange(faq.filter((_, j) => j !== i))} data-testid={`${prefix}-del-${i}`}><Trash2 className="h-3 w-3" /></Button>
        </div>))}
      <Button size="sm" variant="outline" onClick={() => onChange([...faq, { q: "", a: "", approved: true }])} data-testid={`${prefix}-add`}><Plus className="mr-1 h-3 w-3" />Add answer</Button>
    </div>
  );
}
